import React from "react";
import EntityForm from "modules/entity/forms";
import Form from "./form";
import get from "lodash/get";
import useTranslation from "../../../hooks/useTranslation";

const Update = ({ showUpdateModal, selected }) => {
  const { tr } = useTranslation();

  return (
    <EntityForm.Main
      method="put"
      entity="storages"
      name="all"
      url={`/storages/${get(selected, "id")}`}
      normalizeData={(data) => data}
      id={get(selected, "id")}
      updateData={true}
      onSuccess={(data, resetForm) => {
        resetForm();
        showUpdateModal(false);
      }}
      fields={[
        {
          name: "name",
          value: get(selected, "name"),
          required: true,
        },
        {
          name: "status",
          value: get(selected, "status") === 1,
          onSubmitValue: (value) => (value ? 1 : 0),
        },
      ]}
    >
      {({ isSubmitting, values, setFieldValue }) => {
        return (
          <div>
            <div className="modal-title">{tr("Изменить склад")}</div>
            <div className="modal-body">
              <Form
                {...{ isSubmitting, values, setFieldValue, isUpdate: true }}
              />
            </div>
          </div>
        );
      }}
    </EntityForm.Main>
  );
};

export default Update;
